import { render } from "./referee-add-doctor.vue?vue&type=template&id=3577d7be&scoped=true"
import script from "./referee-add-doctor.vue?vue&type=script&lang=js"
export * from "./referee-add-doctor.vue?vue&type=script&lang=js"

import "./referee-add-doctor.vue?vue&type=style&index=0&id=3577d7be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3577d7be"]])

export default __exports__